import { useTranslation } from 'react-i18next';
import { getResponderBadge, translatedTitle } from '@/lib';
import { Badge } from '..';

export const ResponderTooltip = ({ responder, latestResponder, incidentAssigneeStatusList }) => {
  const { t } = useTranslation();

  const statusIdToDisplayNameMap = (incidentAssigneeStatusList || []).reduce((acc, status) => {
    acc[status.id] = status.display_name;
    return acc;
  }, {});

  const handleResponderStatus = id => {
    let filterResponders = latestResponder?.filter(responders => responders?.id == id);
    return {
      badgeInfo: getResponderBadge(filterResponders[0], statusIdToDisplayNameMap),
      incidentTitle: filterResponders[0]?.latestIncident?.title || '-',
    };
  };

  const responderData = handleResponderStatus(responder?.id);

  return (
    <div className="rounded-lg bg p-4 shadow-lg gap-2">
      <div>
        <div className="font-semibold pb-1">{responder?.displayName}</div>
        <div className="border-t"></div>
        <div className="flex flex-col">
          <div className="pt-1">{translatedTitle(responderData.incidentTitle)}</div>
          <Badge variant={responderData.badgeInfo?.variant} size="sm" className="text-xs">
            {t('RESPONDER_STATUS', { returnObjects: true }).find(
              status => status.value === responderData.badgeInfo.label
            )?.label || responderData.badgeInfo.label}
          </Badge>
        </div>
      </div>
    </div>
  );
};
